module.exports = {"230921001":"新起街道","230921002":"新华街道","230921003":"元明街道","230921004":"铁西街道","230921005":"城西街道","230921100":"勃利镇","230921101":"小五站镇","230921102":"大四站镇","230921103":"双河镇","230921104":"倭肯镇","230921200":"青山乡","230921202":"永恒乡","230921203":"抢垦乡","230921204":"杏树朝鲜族乡","230921205":"吉兴朝鲜族满族乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/230921.json
// module id = 772
// module chunks = 0